/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ChargeableTripsRow,
    ChargeableTripsRowFromJSON,
    ChargeableTripsRowFromJSONTyped,
    ChargeableTripsRowToJSON,
} from './';

/**
 * 利用実績リスト
 * @export
 * @interface ChargeableTripsList
 */
export interface ChargeableTripsList {
    /**
     * 
     * @type {Array<ChargeableTripsRow>}
     * @memberof ChargeableTripsList
     */
    trips?: Array<ChargeableTripsRow>;
}

export function ChargeableTripsListFromJSON(json: any): ChargeableTripsList {
    return ChargeableTripsListFromJSONTyped(json, false);
}

export function ChargeableTripsListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChargeableTripsList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'trips': !exists(json, 'trips') ? undefined : ((json['trips'] as Array<any>).map(ChargeableTripsRowFromJSON)),
    };
}

export function ChargeableTripsListToJSON(value?: ChargeableTripsList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'trips': value.trips === undefined ? undefined : ((value.trips as Array<any>).map(ChargeableTripsRowToJSON)),
    };
}


